<script setup>
import { useRouterStore } from '@/stores/router';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
    label: String,
    action: String,
    icon: Boolean,
    type: String,
    disabled: Boolean,
})

const routerStore = useRouterStore();

// Tela aberta direto pela URL (link externo, aba nova) ainda não tem rota salva na store:
// volta pelo histórico do navegador quando houver, senão vai para o início.
const voltarSemRotaSalva = () => {
    if (window.history.state?.back) {
        router.go(-1);
    } else {
        router.push({ name: 'home' });
    }
};

const voltarRota = async () => {
    if (props.disabled) {
        return;
    }

    if (props.action == 'historicoAnterior') {
        window.addEventListener('popstate', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, { once: true });
        router.go(-1);
    }

    if (props.action == 'rotaAnterior') {
        if (!routerStore.ultimaRotaVisitada?.name) return voltarSemRotaSalva();

        const { name, params, query } = routerStore.ultimaRotaVisitada;
        router.push({
            name,
            ...(params?.id != null ? { params: { id: params.id } } : {}),
            ...(query && Object.keys(query).length ? { query } : {})
        });
    }
    if (props.action == 'rotaOrigem') {
        if (!routerStore.rotaOrigem?.name) return voltarSemRotaSalva();

        router.push({ name: routerStore.rotaOrigem.name });
    }

    window.addEventListener('scroll', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, { once: true });
}

const rotasLabel = [
    { name: 'home', label: 'a página inicial' },
    { name: 'detalheProjeto', label: 'os detalhes do projeto' },
    { name: 'detalheInstrumentoJuridico', label: 'os detalhes do instrumento jurídico' },
    { name: 'detalheSolicitacao', label: 'os detalhes da solicitação' },
    { name: 'listaProjetos', label: 'a lista de projetos' },
    { name: 'listaInstrumentosJuridicos', label: 'a lista de instrumentos jurídicos' },
    { name: 'ordenadorPagamentos', label: 'a lista de pagamentos' },
    { name: 'ordenadorContratacoes', label: 'a lista de contratações' },
    { name: 'listaPagamentos', label: 'a lista de pagamentos' },
    { name: 'meusProjetos', label: 'seus projetos' },
    { name: 'perfil', label: 'o detalhe de perfil' },
    { name: 'listaFornecedores', label: 'a lista de fornecedores' },
    { name: 'listaSolicitacaoCompras', label: 'a lista de solicitações' },
    { name: 'listaPessoaFisica', label: 'a lista de pessoas físicas' },
    { name: 'listaPessoasJuridicas', label: 'a lista de pessoas jurídicas' },
    { name: 'pagamentos', label: 'a lista de pagamentos' },
    { name: 'membros', label: 'a lista de membros' },
    { name: 'assinaturasPendentes', label: 'a lista de assinaturas' },
    { name: 'assinaturasAssinados', label: 'a lista de assinaturas' },
    { name: 'propostasContratacao', label: 'a lista de propostas de contratação' },
    { name: 'dadosContratacao', label: 'os detalhes da contratação' },
    { name: 'solicitacoesContratacao', label: 'os detalhes da contratação' },
    { name: 'resultadosContratacao', label: 'os detalhes da contratação' },
    { name: 'notasfiscaisContratacao', label: 'os detalhes da contratação' },
    { name: 'dados', label: 'a página anterior' },
    { name: 'metas', label: 'a página anterior' },
    { name: 'rubricas', label: 'a página anterior' },
    { name: 'desembolsos', label: 'a página anterior' },
    { name: 'solicitacoes', label: 'a página anterior' },
    { name: 'listaContratacoes', label: 'a lista de compras' },
]

const verificarRotaLabel = (rota) => {
    if (!rota) return 'a página anterior';
    const rotaEncontrada = rotasLabel.find(r => r.name === rota);
    return rotaEncontrada ? rotaEncontrada.label : 'a página anterior';
}

</script>

<template>
    <div :class="[
        'flex flex-row gap-2 align-items-center font-medium cursor-pointer w-max hover:text-600 select-none text-xs',
        { 'mb-5': type !== 'cancel', 'text-500': !disabled, 'text-gray-400 pointer-events-none': disabled }
    ]" @click="voltarRota()">
        <span class="pi pi-arrow-left text-xs" v-if="icon == true"></span>

        <p v-if="type == 'cancel'" class="text-xs">Cancelar</p>

        <p v-else class="text-xs">
            Voltar 
            <span class="text-xs" v-if="props.action == 'historicoAnterior'">para a página anterior</span>
            <span class="text-xs" v-if="props.action == 'rotaOrigem'">para {{ verificarRotaLabel(routerStore.rotaOrigem?.name) }}</span>
            <span class="text-xs" v-if="props.action == 'rotaAnterior'">para {{ verificarRotaLabel(routerStore.ultimaRotaVisitada?.name) }}</span>
        </p>
    </div>
</template>